import { InjectionToken } from '@angular/core';

// tslint:disable-next-line: variable-name
export const MatSelectCountryLangToken = new InjectionToken<string>('MatSelectCountryLangToken');
